import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="issue-form-hourly-salary"
export default class extends Controller {
  static targets = [
    "saleryDateField",
  ];

  check_salery_date_field (evt) {
    console.log('issue-form-hourly-salery', evt)

    if (evt.params.cnt != 1) return

    const date_field = this.saleryDateFieldTarget.value
    const date = this.parseDate(date_field)

    if (!date) return

    try {
      const day = date.getDate()

      // 0 = So, 1 = mo, 2 = di, 3 = mi, 4 = do, 5 = fr, 6 = sa
      const sub_days = [ 7, 0, 1, 2, 3, 4, 5 ]

      date.setDate(day - sub_days[ date.getDay() ])

      if (Date.parse(date.toDateString()) && date_field.length > 4) {
        for (let i = 0;i < 12;i++) {
          this.saleryDateFieldTargets[ i ].value =
            `${ date.getDate() }.${ date.getMonth() + 1 }.${ date.getFullYear() }`
          date.setDate(date.getDate() - 7)
        }
      }
    } catch (error) {
      console.log("given date is wrong", error, this.saleryDateFieldTarget.value)
    }
  }

  parseDate (input) {
    const parts = input.match(/(\d+)/g)
    try {
      return new Date(parts[ 2 ], parts[ 1 ] - 1, parts[ 0 ])
    } catch (e) {
      return null
    }
  }
}
